import { Box, Grid, GridItem } from '@chakra-ui/react'
import MyDiv from './employeeDetail.style'
import { BankDetails, EductionalDetails, EmployeeDocuments, EmployerDetails, FamilyDetails, PersonalDetails, ProfileDetailCard, Signature } from './components'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import { Navigate, useLocation } from 'react-router'
import { useState } from 'react'
import { useAuth } from '../../../hooks/useAuth'
import IvrCredential from './components/IvrCredential/ivrCredential'

const EmployeeDetail = () => {
  const location = useLocation();
  const { employeeId, myProfile } = location.state || {};
  const [activeTab, setActiveTab] = useState(0);
  const { loginObj, hasPermission } = useAuth();
  const loggedInEmployeeId = loginObj?.employeeId;

  const isOwnProfile = employeeId === loggedInEmployeeId;
  const canViewOthers = hasPermission("Employee", "showAllEmployee") || hasPermission("Employee", "showBranchData");

  const ivrCredential = hasPermission("CandidateMaster", "IVR Calling") && employeeId === loggedInEmployeeId;
  if (!isOwnProfile && !canViewOthers) {
    return (
      <Navigate to="/unauthorized" replace state={{ message: 'You are not authorized to view this employee profile' }} />
    );
  }

  return (
    <MyDiv>
      <Grid className='grid_container' h="100vh" overflow="hidden">
        <GridItem colSpan={4} h="100vh" overflow="hidden">
          <Box position="sticky" top="0" h="100vh" overflowY="auto" className='tab-list-container'>
            <ProfileDetailCard employeeId={employeeId} myProfile={myProfile} />
          </Box>
        </GridItem>

        <GridItem colSpan={8} h="100vh" overflowY="auto" className='tab-list-container' pr={4}>
          <Tabs variant='soft-rounded' onChange={(index) => setActiveTab(index)}>
            <TabList className='tab-list-container' overflowX="auto" py={2} px={4}>
              <Tab className='font-poppins text_sm text_medium' whiteSpace="nowrap">Personal Details</Tab>
              <Tab className='font-poppins text_sm text_medium' whiteSpace="nowrap">Family Details</Tab>
              <Tab className='font-poppins text_sm text_medium' whiteSpace="nowrap">Eductional Details</Tab>
              <Tab className='font-poppins text_sm text_medium' whiteSpace="nowrap">Employer Details</Tab>
              <Tab className='font-poppins text_sm text_medium' whiteSpace="nowrap">Bank Details</Tab>
              <Tab className='font-poppins text_sm text_medium' whiteSpace="nowrap">Employee Documents</Tab>
               <Tab className='font-poppins text_sm text_medium' whiteSpace="nowrap">Signature</Tab>
              {
                ivrCredential && (
                  <Tab className='font-poppins text_sm text_medium' whiteSpace="nowrap">IVR Credential</Tab>
                )
              }
            
            </TabList>

            <TabPanels>
              <TabPanel>
                {activeTab === 0 && <PersonalDetails employeeId={employeeId} />}
              </TabPanel>
              <TabPanel>
                {activeTab === 1 && <FamilyDetails employeeId={employeeId} />}
              </TabPanel>
              <TabPanel>
                {activeTab === 2 && <EductionalDetails employeeId={employeeId} />}
              </TabPanel>
              <TabPanel>
                {activeTab === 3 && <EmployerDetails employeeId={employeeId} />}
              </TabPanel>
              <TabPanel>
                {activeTab === 4 && <BankDetails employeeId={employeeId} />}
              </TabPanel>
              <TabPanel>
                {activeTab === 5 && <EmployeeDocuments employeeId={employeeId} />}
              </TabPanel>
              <TabPanel>
                {activeTab === 6 && <Signature employeeId={employeeId} />}
              </TabPanel>
              {ivrCredential && (<TabPanel>{activeTab === 7 && <IvrCredential employeeId={employeeId} />}</TabPanel>)}
            </TabPanels>
          </Tabs>
        </GridItem>
      </Grid>
    </MyDiv>
  )
}

export default EmployeeDetail
